import TeacherPageForOffice from "./TeacherPageForOffice";

export default TeacherPageForOffice;